<template>
    <div>
        <v-card>
            <Breadcrumbs />
            <v-row style="padding: 0px 16px">
                <v-col cols="3" style="padding: 4px 10px">
                    <!-- PK副标的搜索 -->
                    <v-text-field
                        v-model="search"
                        outlined
                        dense
                        :label="$t('permission.searchPlaceholder')"
                        single-line
                        hide-details
                    >
                    </v-text-field>
                </v-col>

                <v-col cols="5"></v-col>

                <v-col cols="4" class="text-right">
                    <v-btn
                        color="primary"
                        small
                        v-on:click="toggleDialog('add')"
                    >
                        {{ $t("permission.createPermission") }}
                    </v-btn>
                </v-col>
            </v-row>

            <v-row>
                <v-col lg="12" md="12" xs="12" cols="12">
                    <v-data-table
                        dense
                        :search="search"
                        :headers="permissionHeader"
                        :items="permissionData"
                        item-key="id"
                        class="elevation-0"
                        :loading="loading"
                        :items-per-page="-1"
                        id="home-table"
                        :hide-default-footer="false"
                        fixed-header
                        sort-by="id"
                        :header-props="{ sortIcon: null }"
                        :footer-props="{
                            'items-per-page-text': $t(
                                'common.table.rowsPerPage'
                            ),
                        }"
                    >
                        <template v-slot:item.action="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        dense
                                        v-on:click="toggleDialog('add', item)"
                                        >mdi-content-copy</v-icon
                                    >
                                </template>
                                <span>{{
                                    $t("permission.copyFrom") +
                                    item.permission_name
                                }}</span>
                            </v-tooltip>

                            {{ "" }}
                            <v-icon
                                dense
                                v-on:click="toggleDialog('update', item)"
                                >mdi-pen</v-icon
                            >
                            {{ "" }}
                            <v-icon dense v-on:click="deleteConfirmation(item)"
                                >mdi-delete</v-icon
                            >
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog
            v-model="dialogPermission.visible"
            :fullscreen="dialogPermission.fullscreen"
            width="1400"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        dialogPermission.title
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="
                            dialogPermission.fullscreen =
                                !dialogPermission.fullscreen
                        "
                        ><v-icon>mdi-arrow-expand</v-icon></v-btn
                    >
                    <v-btn
                        color="white"
                        icon
                        @click="dialogPermission.visible = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                :label="this.$t('permission.permissionName')"
                                v-model="dialogPermission.permission_name"
                                hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" v-if="dialogPermission.id === -1">
                            <v-select
                                :label="
                                    this.$t('permission.copyFrom') +
                                    this.$t('permission.optional')
                                "
                                :items="permissionData"
                                item-text="permission_name"
                                item-value="permission"
                                @change="(e) => changeCopyFrom(e)"
                                clearable
                                hide-details
                            ></v-select>
                        </v-col>

                        <v-col cols="10" class="pb-0">
                            <p style="margin: 0">
                                {{ this.$t("permission.permissionDetails") }}
                            </p>
                        </v-col>
                        <v-col cols="2" class="pb-0">
                            <v-switch
                                v-model="jsonView"
                                @click="() => changeView()"
                                :label="
                                    jsonView
                                        ? this.$t('permission.uiMode')
                                        : this.$t('permission.jsonMode')
                                "
                                hide-details
                                style="margin: 0; padding: 0"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" class="pd-0" v-if="jsonView">
                            <div style="overflow: scroll; height: 70vh">
                                <JsonEditor
                                    ref="jsonEditor"
                                    v-model="dialogPermission.permission"
                                    v-if="loadJson"
                                />
                            </div>
                        </v-col>
                        <v-col cols="12" class="pd-0" v-else>
                            <div style="overflow: scroll; max-height: 70vh">
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{
                                                $t(
                                                    "permission.siteBookSelection"
                                                )
                                            }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    cols="12"
                                                    class="pt-0 pb-0"
                                                >
                                                    <v-btn
                                                        :color="
                                                            bookSelection.length !==
                                                            bookData.length
                                                                ? 'primary'
                                                                : 'warning'
                                                        "
                                                        style="
                                                            width: 100%;
                                                            height: 20px;
                                                        "
                                                        class="mb-0"
                                                        dense
                                                        hide-details
                                                        @click="selectAll"
                                                        >{{
                                                            bookSelection.length !==
                                                            bookData.length
                                                                ? this.$t(
                                                                      "common.select.selectAll"
                                                                  )
                                                                : this.$t(
                                                                      "common.select.deselectAll"
                                                                  )
                                                        }}</v-btn
                                                    >
                                                </v-col>
                                                <v-col
                                                    cols="3"
                                                    v-for="book in bookData.filter(
                                                        (item) =>
                                                            item.accessible !==
                                                            false
                                                    )"
                                                    :key="book.id"
                                                    style="
                                                        padding-top: 0;
                                                        padding-bottom: 5px;
                                                    "
                                                >
                                                    <v-switch
                                                        v-model="bookSelection"
                                                        color="primary"
                                                        :label="book.book_name"
                                                        :value="book.book_name"
                                                        dense
                                                        hide-details
                                                    ></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.bookPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'bookPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ this.$t("permission.lpPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'lpPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.alertPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'alertPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.searchPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'searchPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.settingsPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'settingsPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.accountMenu") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'accountMenu'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.k8sPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'k8sPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.alertHubPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'alertHubPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.copyTradePage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'copyTradePage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.ibMonitorPage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'ibMonitorPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{
                                                $t(
                                                    "permission.loginMonitorPage"
                                                )
                                            }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'loginMonitorPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{
                                                $t(
                                                    "permission.changeSummaryPage"
                                                )
                                            }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'changeSummaryPage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t("permission.alertMessage") }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row style="padding: 0px 25px">
                                                <v-col
                                                    v-for="key in checkboxKeys[
                                                        'alertMessage'
                                                    ]"
                                                    :key="key"
                                                    cols="3"
                                                >
                                                    <v-checkbox
                                                        v-model="$data[key]"
                                                        hide-details
                                                        style="
                                                            margin: 0;
                                                            padding: 0;
                                                        "
                                                    >
                                                        <template v-slot:label>
                                                            {{
                                                                permissionSettingInfo[
                                                                    key
                                                                ].label
                                                            }}
                                                            <v-tooltip bottom>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-icon
                                                                        color="grey"
                                                                        dark
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        class="pl-1"
                                                                    >
                                                                        mdi-information
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{
                                                                    permissionSettingInfo[
                                                                        key
                                                                    ].tooltip
                                                                }}</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialogPermission.visible = false"
                        :disabled="loading"
                        >{{ $t("common.form.cancel") }}</v-btn
                    >
                    <v-btn
                        color="green darken-1"
                        v-if="dialogPermission.type === 'update'"
                        text
                        @click="updatePermission()"
                        :loading="loading"
                        ><span>{{ $t("common.form.update") }}</span></v-btn
                    >
                    <v-btn
                        color="green darken-1"
                        v-if="dialogPermission.type === 'add'"
                        text
                        @click="createPermission()"
                        :loading="loading"
                        ><span>{{ $t("common.form.add") }}</span></v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <DeleteConfirmDialog
            :confirmPopover="popup"
            :type="$t('common.table.permission')"
            :name="selectedDeletion.permission_name"
            :loading="loading"
            @close="
                () => {
                    popup = false;
                }
            "
            @confirm="deleteConfig"
        ></DeleteConfirmDialog>
    </div>
</template>
<script>
import { snackbar } from "@components/mixins/snackbar";
import { permission } from "@components/mixins/permission";
import { mapState, mapActions } from "vuex";
import Breadcrumbs from "@components/Breadcrumbs";
import JsonEditor from "@components/ComponentJsonEditor";
import validator from "@assets/js/validator";
import DeleteConfirmDialog from "@components/ComponentDeleteConfirmDialog";

export default {
    components: { Breadcrumbs, JsonEditor, DeleteConfirmDialog },
    mixins: [snackbar, permission],
    data() {
        return {
            search: "",
            selectedConfigId: null,
            showEditAlert: 0,
            showEditPermission: 0,
            permissionLoadJson: true,
            selectedPermission: [],
            selectedRole: "",
            permissionConfig: [],
            selectedConfig: "alert",
            alertName:
                "volume_alert, big_lot, mandate, profit_taker, locking_position, trade_on_credit, large_exposure, fast_trade, watch_list, tick_check, withdraw_deposit",
            btnLoading: false,
            dialogPermission: {
                visible: false,
                id: -1,
                permission_name: "",
                permission: null,
                fullscreen: false,
                type: "",
                title: "",
            },
            loadJson: false,
            popup: false,
            selectedDeletion: {},
            jsonView: false,

            // below are the settings for permission
            checkboxKeys: {
                bookPage: [
                    "homeLoginDetailSummary",
                    "mtdVolumeColumn",
                    "mtdPnlColumn",
                    "netEquityColumn",
                    "loginSummaryInfo",
                    "loginSummaryStatistic",
                    "loginSummaryTrades",
                    "extraSymbolDetails",
                    "allowDownloadAll",
                    "dailySummaryIcon",
                    "symbolLoginSwitch",
                    "symbolSnapshot",
                    "loginSnapshot",
                    "devSumUp",
                    "enableLanguageSwitch",
                    "showAiAnalysisButton",
                ],
                lpPage: ["enableLP", "showEODPosition", "lpDownloadAll"],
                alertPage: [
                    "enableAlert",
                    "allowTickMutation",
                    "ibRelatedFieldsAlert",
                    "allowProfileCleanUp",
                ],
                searchPage: [
                    "enableSearch",
                    "allowDownloadRequest",
                    "ibRelatedFieldsSearch",
                ],
                settingsPage: [
                    "alertConfig",
                    "alertHubConfig",
                    "brokerConfig",
                    "serverConfig",
                    "bookConfig",
                    "pkTaker",
                    "routingConfig",
                    "copyTradeConfig",
                    "lpConfig",
                    "notificationConfig",
                    "alertConfigEdit",
                ],
                accountMenu: [
                    "accountPermission",
                    "accountManagement",
                    "accountConfig",
                    "accountProfile",
                ],
                k8sPage: ["enableK8s"],
                alertHubPage: ["enableAlertHub", "enableAlertHubUpgrade"],
                copyTradePage: ["enableCopyTrade"],
                ibMonitorPage: [
                    "enableIBMonitor",
                    "ibLoginDetailSummary",
                    "ibLoginSummaryInfo",
                    "ibLoginSummaryStatistic",
                    "ibLoginSummaryTrades",
                    "ibExtraSymbolDetails",
                ],
                loginMonitorPage: [
                    "enableLoginMonitor",
                    // "ibLoginDetailSummary",
                    // "ibLoginSummaryInfo",
                    // "ibLoginSummaryStatistic",
                    // "ibLoginSummaryTrades",
                    // "ibExtraSymbolDetails",
                ],
                changeSummaryPage: ["enableChangeSummary"],
                alertMessage: [
                    "enableAlertMessagePumping",
                    "enableRiskRating",
                    "enableMarginAlertMessage",
                    "enablePositionRecMessage",
                    "enablePositionPNLMessage",
                    "enableIntradayRiskyAccount",
                    "enableLargeVolumeAlert",
                    "enableMarketNewsMessage",
                    "enableHourlyUpdatesMessage",
                ],
            },
            // book
            bookSelection: [],
            // home
            homeLoginDetailSummary: false,
            mtdVolumeColumn: false,
            mtdPnlColumn: false,
            netEquityColumn: false,
            loginSummaryInfo: false,
            loginSummaryStatistic: false,
            loginSummaryTrades: false,
            extraSymbolDetails: false,
            allowDownloadAll: false,
            dailySummaryIcon: false,
            symbolLoginSwitch: false,
            symbolSnapshot: false,
            loginSnapshot: false,
            devSumUp: false,
            enableLanguageSwitch: false,
            showAiAnalysisButton: false,
            // lp
            enableLP: false,
            showEODPosition: false,
            lpDownloadAll: false,
            // alert
            enableAlert: false,
            allowTickMutation: false,
            allowProfileCleanUp: false,
            ibRelatedFieldsAlert: false,
            //search:
            enableSearch: false,
            allowDownloadRequest: false,
            ibRelatedFieldsSearch: false,
            // settings
            alertConfig: false,
            alertHubConfig: false,
            brokerConfig: false,
            serverConfig: false,
            bookConfig: false,
            pkTaker: false,
            routingConfig: false,
            copyTradeConfig: false,
            alertConfigEdit: false,
            lpConfig: false,
            notificationConfig: false,
            // k8s
            enableK8s: false,
            //copy trade
            enableCopyTrade: false,
            // Alert Hub
            enableAlertHub: false,
            enableAlertHubUpgrade: false,
            // IB Monitor
            enableIBMonitor: false,
            ibExtraSymbolDetails: false,
            ibLoginSummaryInfo: false,
            ibLoginSummaryStatistic: false,
            ibLoginSummaryTrades: false,
            ibLoginDetailSummary: false,
            // Login Monitor
            enableLoginMonitor: false,
            // Change Summary
            enableChangeSummary: false,
            // account
            accountProfile: false,
            accountConfig: false,
            accountPermission: false,
            accountManagement: false,
            // alert message
            enableAlertMessagePumping: false,
            enableRiskRating: false,
            enableMarginAlertMessage: false,
            enablePositionRecMessage: false,
            enablePositionPNLMessage: false,
            enableIntradayRiskyAccount: false,
            enableLargeVolumeAlert: false,
            enableMarketNewsMessage: false,
            enableHourlyUpdatesMessage: false,
        };
    },
    watch: {
        permissionData() {
            this.dialogPermission.visible = false;
            this.popup = false;
            const permissionId = this.$route.query.permission_id;
            if (permissionId !== undefined) {
                const item = this.permissionData.filter(
                    (item) => item.id == permissionId
                )[0];
                this.toggleDialog("update", item);
            }
        },
        jsonView(nv) {
            if (nv === false) {
                this.updateCheckboxStatus(this.dialogPermission.permission);
            }
        },
        homeLoginDetailSummary(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "homeLoginDetailSummary"
            );
        },
        enableLanguageSwitch(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "enableLanguageSwitch"
            );
        },
        showAiAnalysisButton(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "showAiAnalysisButton"
            );
        },
        ibLoginDetailSummary(nv) {
            this.updatePermissionData(
                nv,
                "ibMonitor",
                "function",
                "ibLoginDetailSummary"
            );
        },
        extraSymbolDetails(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "extraSymbolDetails"
            );
        },
        allowDownloadAll(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "allowDownloadAll"
            );
        },
        ibExtraSymbolDetails(nv) {
            this.updatePermissionData(
                nv,
                "ibMonitor",
                "function",
                "ibExtraSymbolDetails"
            );
        },
        dailySummaryIcon(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "dailySummaryIcon"
            );
        },
        symbolLoginSwitch(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "symbolLoginSwitch"
            );
        },
        mtdVolumeColumn(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "mtdVolumeColumn"
            );
        },
        mtdPnlColumn(nv) {
            this.updatePermissionData(nv, "book", "function", "mtdPnlColumn");
        },
        netEquityColumn(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "netEquityColumn"
            );
        },
        loginSummaryInfo(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "loginSummaryInfo"
            );
        },
        ibLoginSummaryInfo(nv) {
            this.updatePermissionData(
                nv,
                "ibMonitor",
                "function",
                "ibLoginSummaryInfo"
            );
        },
        loginSummaryStatistic(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "loginSummaryStatistic"
            );
        },
        ibLoginSummaryStatistic(nv) {
            this.updatePermissionData(
                nv,
                "ibMonitor",
                "function",
                "ibLoginSummaryStatistic"
            );
        },
        loginSummaryTrades(nv) {
            this.updatePermissionData(
                nv,
                "book",
                "function",
                "loginSummaryTrades"
            );
        },
        devSumUp(nv) {
            this.updatePermissionData(nv, "book", "function", "devSumUp");
        },
        loginSnapshot(nv) {
            this.updatePermissionData(nv, "book", "function", "loginSnapshot");
        },
        symbolSnapshot(nv) {
            this.updatePermissionData(nv, "book", "function", "symbolSnapshot");
        },
        ibLoginSummaryTrades(nv) {
            this.updatePermissionData(
                nv,
                "ibMonitor",
                "function",
                "ibLoginSummaryTrades"
            );
        },
        enableLP(nv) {
            this.updatePermissionData(nv, "lp", null, null);
        },
        showEODPosition(nv) {
            this.updatePermissionData(nv, "lp", "child", "showEODPosition");
        },
        lpDownloadAll(nv) {
            this.updatePermissionData(nv, "lp", "child", "lpDownloadAll");
        },
        enableSearch(nv) {
            this.updatePermissionData(nv, "search", null, null);
        },
        allowDownloadRequest(nv) {
            this.updatePermissionData(
                nv,
                "search",
                "child",
                "allowDownloadRequest"
            );
        },
        ibRelatedFieldsSearch(nv) {
            this.updatePermissionData(
                nv,
                "search",
                "child",
                "ibRelatedFieldsSearch"
            );
        },
        ibRelatedFieldsAlert(nv) {
            this.updatePermissionData(
                nv,
                "alert",
                "child",
                "ibRelatedFieldsAlert"
            );
        },
        enableAlert(nv) {
            this.updatePermissionData(nv, "alert", "child", "overview");
        },
        allowTickMutation(nv) {
            this.updatePermissionData(nv, "alert", "child", "tickMutation");
        },
        allowProfileCleanUp(nv) {
            this.updatePermissionData(nv, "alert", "child", "allowProfileCleanUp");
        },
        alertConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "alertConfig");
        },
        alertHubConfig(nv) {
            this.updatePermissionData(
                nv,
                "settings",
                "child",
                "alertHubConfig"
            );
        },
        brokerConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "brokerConfig");
        },
        serverConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "serverConfig");
        },
        bookConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "bookConfig");
        },
        pkTaker(nv) {
            this.updatePermissionData(nv, "settings", "child", "pkTaker");
        },
        bookSelection(nv) {
            if (nv) {
                this.checkStructure();
            }
        },
        routingConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "routingConfig");
        },
        copyTradeConfig(nv) {
            this.updatePermissionData(
                nv,
                "settings",
                "child",
                "copyTradeConfig"
            );
        },
        alertConfigEdit(nv) {
            this.updatePermissionData(
                nv,
                "settings",
                "function",
                "alertConfigEdit"
            );
        },
        lpConfig(nv) {
            this.updatePermissionData(nv, "settings", "child", "lpConfig");
        },
        notificationConfig(nv) {
            this.updatePermissionData(
                nv,
                "settings",
                "child",
                "notificationConfig"
            );
        },
        enableK8s(nv) {
            this.updatePermissionData(nv, "k8s", null, null);
        },
        enableCopyTrade(nv) {
            this.updatePermissionData(nv, "copyTrade", null, null);
        },
        enableChangeSummary(nv) {
            this.updatePermissionData(nv, "changeSummary", null, null);
        },
        enableAlertHub(nv) {
            this.updatePermissionData(nv, "alertHub", "child", "index");
        },
        enableAlertHubUpgrade(nv) {
            this.updatePermissionData(
                nv,
                "alertHub",
                "child",
                "enableAlertHubUpgrade"
            );
        },
        enableIBMonitor(nv) {
            this.updatePermissionData(nv, "ibMonitor", null, null);
        },
        enableLoginMonitor(nv) {
            this.updatePermissionData(nv, "loginMonitor", null, null);
        },
        accountProfile(nv) {
            this.updatePermissionData(nv, "account", "child", "profile");
        },
        accountConfig(nv) {
            this.updatePermissionData(nv, "account", "child", "config");
        },
        accountPermission(nv) {
            this.updatePermissionData(nv, "account", "child", "permission");
        },
        accountManagement(nv) {
            this.updatePermissionData(nv, "account", "child", "management");
        },
        enableAlertMessagePumping(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableAlertMessagePumping"
            );
        },
        enableRiskRating(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableRiskRating"
            );
        },
        enableMarginAlertMessage(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableMarginAlertMessage"
            );
        },
        enablePositionRecMessage(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enablePositionRecMessage"
            );
        },
        enablePositionPNLMessage(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enablePositionPNLMessage"
            );
        },
        enableIntradayRiskyAccount(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableIntradayRiskyAccount"
            );
        },
        enableLargeVolumeAlert(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableLargeVolumeAlert"
            );
        },
        enableMarketNewsMessage(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableMarketNewsMessage"
            );
        },
        enableHourlyUpdatesMessage(nv) {
            this.updatePermissionData(
                nv,
                "alertMessage",
                "child",
                "enableHourlyUpdatesMessage"
            );
        },
    },
    computed: {
        ...mapState("SitePermissionConfig", [
            "permissionData",
            "permissionHeader",
            "loading",
            "permissionSettingInfo",
        ]),
        ...mapState("SettingsBooks", ["bookData"]),
        isSwitchDisabled() {
            return !this.isPermissionValidJson();
        },
    },
    methods: {
        ...mapActions("SitePermissionConfig", [
            "getPermissionAction",
            "postPermissionAction",
            "putPermissionAction",
            "deletePermissionAction",
        ]),
        ...mapActions("SettingsBooks", ["getBooksAction"]),
        updatePermissionData(nv, base, key, fnName) {
            if (nv) {
                this.checkStructure();
            } else {
                const fp = this.dialogPermission.permission?.frontPermission;

                if (!fp) return;

                if (key === null) {
                    if (fp[base]) {
                        delete fp[base];
                    }
                } else {
                    const fnList = fp[base]?.[key];
                    if (Array.isArray(fnList)) {
                        fp[base][key] = fnList.filter(
                            (item) => item !== fnName
                        );
                    }
                }
            }
        },
        changeCopyFrom(settings) {
            this.dialogPermission.permission = { ...settings };
            this.updateCheckboxStatus({ ...settings });
        },
        toggleDialog(type, data) {
            this.dialogPermission.visible = true;
            this.dialogPermission.type = type;
            this.jsonView = false;

            if (type === "add") {
                const resetBooleans = [
                    "homeLoginDetailSummary",
                    "ibLoginDetailSummary",
                    "extraSymbolDetails",
                    "allowDownloadAll",
                    "ibExtraSymbolDetails",
                    "dailySummaryIcon",
                    "symbolLoginSwitch",
                    "mtdVolumeColumn",
                    "mtdPnlColumn",
                    "netEquityColumn",
                    "loginSummaryInfo",
                    "ibLoginSummaryInfo",
                    "loginSummaryStatistic",
                    "ibLoginSummaryStatistic",
                    "loginSummaryTrades",
                    "devSumUp",
                    "loginSnapshot",
                    "symbolSnapshot",
                    "ibLoginSummaryTrades",
                    "enableLP",
                    "showEODPosition",
                    "lpDownloadAll",
                    "alertConfig",
                    "alertHubConfig",
                    "brokerConfig",
                    "serverConfig",
                    "bookConfig",
                    "pkTaker",
                    "routingConfig",
                    "copyTradeConfig",
                    "alertConfigEdit",
                    "lpConfig",
                    "notificationConfig",
                    "enableSearch",
                    "allowDownloadRequest",
                    "ibRelatedFieldsSearch",
                    "ibRelatedFieldsAlert",
                    "enableAlert",
                    "allowTickMutation",
                    "allowProfileCleanUp",
                    "enableK8s",
                    "enableCopyTrade",
                    "enableChangeSummary",
                    "enableAlertHub",
                    "enableAlertHubUpgrade",
                    "enableIBMonitor",
                    "enableLoginMonitor",
                    "accountProfile",
                    "accountConfig",
                    "accountPermission",
                    "accountManagement",
                    "enableAlertMessagePumping",
                    "enableLanguageSwitch",
                    "showAiAnalysisButton",
                    "enableRiskRating",
                    "enableMarginAlertMessage",
                    "enablePositionRecMessage",
                    "enablePositionPNLMessage",
                    "enableIntradayRiskyAccount",
                    "enableLargeVolumeAlert",
                    "enableMarketNewsMessage",
                    "enableHourlyUpdatesMessage",
                ];

                this.dialogPermission.title = this.$t(
                    "permission.addNewPermission"
                );
                this.dialogPermission.permission_name = "";

                if (!!data) {
                    this.dialogPermission.id = -2;
                    this.changeCopyFrom(data.permission);
                } else {
                    this.dialogPermission.id = -1;
                    this.dialogPermission.permission = {};

                    resetBooleans.forEach((flag) => {
                        this[flag] = false;
                    });
                }
            } else {
                // update existing permission
                this.dialogPermission.title = this.$t(
                    "permission.updatePermission"
                );
                this.dialogPermission.permission_name = data.permission_name;
                this.dialogPermission.id = data.id;
                this.dialogPermission.permission = data.permission;

                this.updateCheckboxStatus(data.permission);
            }

            this.loadJson = false;
            this.$nextTick(() => {
                this.loadJson = true;
            });
        },
        updateCheckboxStatus(permission) {
            const fp = permission?.frontPermission ?? {};

            const bindings = {
                allowDownloadRequest: "search.child",
                ibRelatedFieldsSearch: "search.child",
                ibRelatedFieldsAlert: "alert.child",
                alertConfig: "settings.child",
                alertHubConfig: "settings.child",
                brokerConfig: "settings.child",
                serverConfig: "settings.child",
                bookConfig: "settings.child",
                pkTaker: "settings.child",
                routingConfig: "settings.child",
                copyTradeConfig: "settings.child",
                lpConfig: "settings.child",
                notificationConfig: "settings.child",
                enableAlertMessagePumping: "alertMessage.child",
                enableLanguageSwitch: "book.function",
                showAiAnalysisButton: "book.function",
                enableRiskRating: "alertMessage.child",
                enableMarginAlertMessage: "alertMessage.child",
                enablePositionRecMessage: "alertMessage.child",
                enablePositionPNLMessage: "alertMessage.child",
                enableIntradayRiskyAccount: "alertMessage.child",
                enableLargeVolumeAlert: "alertMessage.child",
                enableMarketNewsMessage: "alertMessage.child",
                enableHourlyUpdatesMessage: "alertMessage.child",
                homeLoginDetailSummary: "book.function",
                extraSymbolDetails: "book.function",
                allowDownloadAll: "book.function",
                dailySummaryIcon: "book.function",
                symbolLoginSwitch: "book.function",
                mtdVolumeColumn: "book.function",
                mtdPnlColumn: "book.function",
                netEquityColumn: "book.function",
                loginSummaryInfo: "book.function",
                loginSummaryStatistic: "book.function",
                loginSummaryTrades: "book.function",
                devSumUp: "book.function",
                loginSnapshot: "book.function",
                symbolSnapshot: "book.function",
                alertConfigEdit: "settings.function",
                ibLoginDetailSummary: "ibMonitor.function",
                ibExtraSymbolDetails: "ibMonitor.function",
                ibLoginSummaryInfo: "ibMonitor.function",
                ibLoginSummaryStatistic: "ibMonitor.function",
                ibLoginSummaryTrades: "ibMonitor.function",
                enableAlertHubUpgrade: "alertHub.child",
            };
            const fixedValueBindings = {
                enableK8s: ["k8s.child", "index"],
                enableCopyTrade: ["copyTrade.child", "index"],
                enableChangeSummary: ["changeSummary.child", "index"],
                enableAlertHub: ["alertHub.child", "index"],
                enableIBMonitor: ["ibMonitor.child", "index"],
                enableLoginMonitor: ["loginMonitor.child", "index"],
                enableAlert: ["alert.child", "overview"],
                allowTickMutation: ["alert.child", "tickMutation"],
                allowProfileCleanUp: ["alert.child", "allowProfileCleanUp"],
                showEODPosition: ["lp.child", "showEODPosition"],
                lpDownloadAll: ["lp.child", "lpDownloadAll"],
                accountProfile: ["account.child", "profile"],
                accountConfig: ["account.child", "config"],
                accountPermission: ["account.child", "permission"],
                accountManagement: ["account.child", "management"],
            };

            const includesIn = (path, value) => {
                const segments = path.split(".");
                let current = fp;
                for (const seg of segments) {
                    current = current?.[seg];
                    if (!current) return false;
                }
                return Array.isArray(current) ? current.includes(value) : false;
            };

            for (const [key, path] of Object.entries(bindings)) {
                this[key] = includesIn(path, key);
            }
            for (const [key, [path, value]] of Object.entries(
                fixedValueBindings
            )) {
                this[key] = includesIn(path, value);
            }

            this.enableLP = !!fp.lp?.child;
            this.enableSearch = !!fp.search?.child;

            this.bookSelection = fp.bookSelection || [];
        },
        checkStructure() {
            const dp = this.dialogPermission;

            // Ensure base structure
            if (typeof dp.permission !== "object") {
                dp.permission = {};
            }
            if (typeof dp.permission.frontPermission !== "object") {
                dp.permission.frontPermission = {};
            }
            const fp = dp.permission.frontPermission;

            const ensureSection = (base, type = "function") => {
                fp[base] ??= {};
                if (!Array.isArray(fp[base][type])) {
                    fp[base][type] = [];
                }
            };

            // Book selection
            if (this.bookSelection) {
                fp.bookSelection = this.bookSelection;
            }

            // Book functions
            const bookFunctions = [
                ["homeLoginDetailSummary", this.homeLoginDetailSummary],
                ["extraSymbolDetails", this.extraSymbolDetails],
                ["enableLanguageSwitch", this.enableLanguageSwitch],
                ["showAiAnalysisButton", this.showAiAnalysisButton],
                ["allowDownloadAll", this.allowDownloadAll],
                ["dailySummaryIcon", this.dailySummaryIcon],
                ["symbolLoginSwitch", this.symbolLoginSwitch],
                ["mtdVolumeColumn", this.mtdVolumeColumn],
                ["mtdPnlColumn", this.mtdPnlColumn],
                ["netEquityColumn", this.netEquityColumn],
                ["loginSummaryInfo", this.loginSummaryInfo],
                ["loginSummaryStatistic", this.loginSummaryStatistic],
                ["loginSummaryTrades", this.loginSummaryTrades],
                ["devSumUp", this.devSumUp],
                ["symbolSnapshot", this.symbolSnapshot],
                ["loginSnapshot", this.loginSnapshot],
            ]
                .filter(([_, flag]) => flag)
                .map(([name]) => name);

            if (bookFunctions.length) {
                ensureSection("book", "child");
                ensureSection("book", "function");
                fp.book.function = bookFunctions;
            }

            // LP
            if (this.enableLP) fp.lp = { child: [] };
            const lpChildren = [
                this.showEODPosition && "showEODPosition",
                this.lpDownloadAll && "lpDownloadAll",
            ].filter(Boolean);
            if (lpChildren.length) fp.lp = { child: lpChildren };

            // Search
            const searchChildren = [
                this.enableSearch && "enableSearch",
                this.allowDownloadRequest && "allowDownloadRequest",
                this.ibRelatedFieldsSearch && "ibRelatedFieldsSearch",
            ].filter(Boolean);
            if (searchChildren.length) fp.search = { child: searchChildren };

            // Alert
            const alertChildren = [
                this.enableAlert && "overview",
                this.allowTickMutation && "tickMutation",
                this.allowProfileCleanUp && "allowProfileCleanUp",
                this.ibRelatedFieldsAlert && "ibRelatedFieldsAlert",
            ].filter(Boolean);
            if (alertChildren.length) fp.alert = { child: alertChildren };

            // Account
            const accountChildren = [
                this.accountProfile && "profile",
                this.accountConfig && "config",
                this.accountPermission && "permission",
                this.accountManagement && "management",
            ].filter(Boolean);
            if (accountChildren.length) {
                fp.account = { child: accountChildren };
                if (accountChildren.includes("config"))
                    ensureSection("settings");
            }

            // Settings
            const settingsChildren = [
                this.alertConfig && "alertConfig",
                this.alertHubConfig && "alertHubConfig",
                this.brokerConfig && "brokerConfig",
                this.serverConfig && "serverConfig",
                this.bookConfig && "bookConfig",
                this.pkTaker && "pkTaker",
                this.routingConfig && "routingConfig",
                this.copyTradeConfig && "copyTradeConfig",
                this.lpConfig && "lpConfig",
                this.notificationConfig && "notificationConfig",
            ].filter(Boolean);

            const settingsFunctions = [
                this.alertConfigEdit && "alertConfigEdit",
            ].filter(Boolean);

            if (settingsChildren.length || settingsFunctions.length) {
                fp.settings = {
                    ...(settingsChildren.length
                        ? { child: settingsChildren }
                        : {}),
                    ...(settingsFunctions.length
                        ? { function: settingsFunctions }
                        : {}),
                };
            }

            // IB Monitor
            const ibFunctions = [
                this.ibLoginDetailSummary && "ibLoginDetailSummary",
                this.ibExtraSymbolDetails && "ibExtraSymbolDetails",
                this.ibLoginSummaryInfo && "ibLoginSummaryInfo",
                this.ibLoginSummaryStatistic && "ibLoginSummaryStatistic",
                this.ibLoginSummaryTrades && "ibLoginSummaryTrades",
            ].filter(Boolean);
            const ibChildren = this.enableIBMonitor ? ["index"] : [];

            if (ibFunctions.length || ibChildren.length) {
                fp.ibMonitor = {
                    ...(ibChildren.length ? { child: ibChildren } : {}),
                    ...(ibFunctions.length ? { function: ibFunctions } : {}),
                };
            }

            //Alert Hub
            const alertHubChildren = [
                this.enableAlertHub && "index",
                this.enableAlertHubUpgrade && "enableAlertHubUpgrade",
            ].filter(Boolean);

            if (this.enableAlertHub || this.enableAlertHubUpgrade) {
                fp.alertHub = {
                    ...{ child: alertHubChildren },
                };
            }

            const loginMonitorChildren = this.enableLoginMonitor
                ? ["index"]
                : [];

            if (loginMonitorChildren.length) {
                fp.loginMonitor = {
                    ...(loginMonitorChildren.length
                        ? { child: loginMonitorChildren }
                        : {}),
                };
            }

            // Miscellaneous simple toggles
            const simpleSections = [
                ["k8s", this.enableK8s],
                ["copyTrade", this.enableCopyTrade],
                ["changeSummary", this.enableChangeSummary],
            ];

            simpleSections.forEach(([key, flag]) => {
                if (flag) fp[key] = { child: ["index"] };
            });

            // Alert Message
            const alertMessageChildren = [
                this.enableAlertMessagePumping && "enableAlertMessagePumping",
                this.enableRiskRating && "enableRiskRating",
                this.enableMarginAlertMessage && "enableMarginAlertMessage",
                this.enablePositionRecMessage && "enablePositionRecMessage",
                this.enablePositionPNLMessage && "enablePositionPNLMessage",
                this.enableIntradayRiskyAccount && "enableIntradayRiskyAccount",
                this.enableLargeVolumeAlert && "enableLargeVolumeAlert",
                this.enableMarketNewsMessage && "enableMarketNewsMessage",
                this.enableHourlyUpdatesMessage && "enableHourlyUpdatesMessage",
            ].filter(Boolean);
            if (alertMessageChildren.length) {
                fp.alertMessage = { child: alertMessageChildren };
            }
        },
        changeView() {
            if (this.jsonView === false) {
                if (!this.isPermissionValidJson()) {
                    this.snackBarDanger(this.$t("permission.invalidJson"));
                    this.$nextTick(() => {
                        this.jsonView = true;
                    });
                }
            }
        },
        updatePermission() {
            if (this.isPermissionValidJson()) {
                if (
                    validator.commonStringValidator(
                        this.dialogPermission.permission_name
                    )
                ) {
                    this.dialogPermission.permission_name =
                        validator.cleanUpStringData(
                            this.dialogPermission.permission_name
                        );
                    this.putPermissionAction(this.dialogPermission);
                } else {
                    this.snackBarDanger(this.$t("permission.nameInvalid"));
                }
            } else {
                this.snackBarDanger(this.$t("permission.invalidJson"));
            }
        },
        createPermission() {
            if (this.isPermissionValidJson()) {
                if (
                    validator.commonStringValidator(
                        this.dialogPermission.permission_name
                    )
                ) {
                    this.dialogPermission.permission_name =
                        validator.cleanUpStringData(
                            this.dialogPermission.permission_name
                        );
                    this.postPermissionAction(this.dialogPermission);
                } else {
                    this.snackBarDanger(this.$t("permission.nameInvalid"));
                }
            } else {
                this.snackBarDanger(this.$t("permission.invalidJson"));
            }
        },
        deleteConfirmation(item) {
            this.selectedDeletion = item;
            this.popup = true;
        },
        deleteConfig() {
            this.deletePermissionAction({ id: this.selectedDeletion.id });
        },
        isPermissionValidJson() {
            try {
                if (this.dialogPermission.permission.constructor === String) {
                    this.dialogPermission.permission = JSON.parse(
                        this.dialogPermission.permission
                    );
                }
                return true;
            } catch (e) {
                console.log("Json syntax error");
                return false;
            }
        },
        onBookSelectionChange(book, value) {
            if (!!value) {
                this.bookSelection.push(book.book_name);
            } else {
                this.bookSelection = this.bookSelection.filter(
                    (name) => name !== book.book_name
                );
            }
        },
        selectAll() {
            if (this.bookSelection.length !== this.bookData.length) {
                const allBooks = this.bookData.map((item) => item.book_name);
                this.bookSelection = allBooks;
            } else {
                this.bookSelection = [];
            }
        },
    },
    mounted() {
        this.getBooksAction();
        this.getPermissionAction();
    },
};
</script>

<style scoped>
.p {
    margin: 0px;
}
</style>
